import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=01bb1921&scoped=true"
import script from "./ProductMenu.vue?vue&type=script&lang=js"
export * from "./ProductMenu.vue?vue&type=script&lang=js"
import style0 from "./ProductMenu.vue?vue&type=style&index=0&id=01bb1921&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bb1921",
  null
  
)

export default component.exports